import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { TerminalDepositModesEnum } from '@app/dev/constants/enums/terminalDepositModes';
import KeyboardFormField from '@common/components/keyboardFormField';
import { useTranslation } from '@common/hooks/translation';
import { fields } from './constants/fields';

const WinIdentificationPopup = ({
  defer,
  player,
  autofillData,
}) => {
  const t = useTranslation();
  const {
    depositMode,
    playerInfo,
    isAdminLoggedIn,
  } = useSelector((state) => state.terminal);
  const [isUserDetected, setIsUserDetected] = useState(false);

  const activePlayerInfo = player || {
    ...(playerInfo || {}),
    CNP: playerInfo?.PersonalId,
  };

  const parts = autofillData?.split('.') ?? [];
  const autoFillFirstName = parts[0]?.replace('Firstname: ', '')?.trim();
  const autoFillLastName = parts[1]?.replace('Lastname: ', '')?.trim()?.replace('.', '');
  const autoFillCnp = parts[2]?.replace('Cnp: ', '')?.trim()?.replace('.', '');

  const [errors, setErrors] = useState({});
  const [form, setForm] = useState({
    Name: autoFillFirstName ?? '',
    Surname: autoFillLastName ?? '',
    CNP: autoFillCnp ?? '',
    ...(depositMode === TerminalDepositModesEnum.Octo ? player : {}),
  });

  useEffect(() => {
    if (parts.length) {
      setIsUserDetected(true);
    }
  }, [parts.length]);

  const disabled = fields.some((field) => {
    const { fieldName } = field;
    return form[fieldName] === '' || errors[fieldName];
  });

  const validateField = (fieldName, value) => {
    const field = fields.find((item) => item.name === fieldName);

    const {
      isFieldValid,
      errorMessage,
    } = field;

    if (!isFieldValid(value)) {
      setErrors({
        ...errors,
        [fieldName]: errorMessage,
      });
    } else if (errors[fieldName]) {
      setErrors({
        ...errors,
        [fieldName]: null,
      });
    }

    if (fieldName === 'CNP') {
      if (value?.toLowerCase() === player?.CNP?.toLowerCase()) {
        setIsUserDetected(true);
        setForm({
          ...form,
          ...activePlayerInfo,
        });
      } else if (isUserDetected) {
        setIsUserDetected(false);
        setForm({
          CNP: value,
          Name: '',
          Surname: '',
        });
      }
    }
  };

  const onChange = (name, value) => {
    setForm({
      ...form,
      [name]: value,
    });
    validateField(name, value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    defer.resolve(form);
  };

  return (
    <div className="popup-content popup-small win-identification">
      <h3 className="popup-title">{t('Pay won bet')}</h3>
      <div className="popup-main-content">
        <div className="input-wrapper">
          {fields.map((item) => (
            <KeyboardFormField
              key={item.name}
              name={item.fieldName}
              value={form[item.name]}
              disabled={isUserDetected}
              onChange={(value) => onChange(item.name, value)}
              errorMessage={errors[item.fieldName]}
            />
          ))}
        </div>
        {!isAdminLoggedIn && (
          <div className="register-info">
            <i className="global-icon icon-login-admin register-admin-icon" />
            <div className="admin-check">{t('Please ask administration for confirmation')}</div>
          </div>
        )}
      </div>
      <div className="popup-actions">
        <button
          type="button"
          onClick={() => defer.resolve(null)}
          className={`popup-cancel-button ${!isAdminLoggedIn ? 'register-cancel' : ''}`}
        >
          {t('Cancel')}
        </button>
        <button
          disabled={disabled || !isAdminLoggedIn}
          type="button"
          onClick={handleSubmit}
          className="popup-confirm-button"
        >
          {t('Continue')}
        </button>
      </div>
    </div>
  );
};

WinIdentificationPopup.propTypes = {
  player: PropTypes.object,
  defer: PropTypes.object.isRequired,
  autofillData: PropTypes.string,
};

export default WinIdentificationPopup;
